<ng-container *transloco="let t">
<div class="modal-header">

  <h2>{{ t('auth.sendCode.title') }}</h2>

  <!-- hack to fool ngbModal autofocus -->
  <input type="text" style="display:none" />

  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <span class="svg-icon svg-icon-2x">
      <close-x-svg-icon></close-x-svg-icon>
    </span>
  </div>
</div>

<div class="modal-body py-5 px-lg-17">
  <div class="alert alert-info bg-light-success d-flex align-items-center p-5 mb-10">
    <span class="svg-icon svg-icon-2hx svg-icon-info me-3">
      <duotone-safe-svg-icon></duotone-safe-svg-icon>
    </span>
    @if (userName) {
      <div class="d-flex flex-column">
        <span class="mb-3">{{ t('auth.sendCode.willSendCode') }}</span>
        <span>{{ t('auth.sendCode.enterEmailBelow') }}</span>
      </div>
    }
  </div>
  @if (errorMessage) {
    <div class="alert alert-danger d-flex align-items-center p-5 mb-10">
      <span class="svg-icon svg-icon-2hx svg-icon-danger me-3">
        <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
      </span>
      <div class="d-flex flex-column">
        <span>{{errorMessage}}</span>
      </div>
    </div>
  }
  <form #sendCodeForm="ngForm" class="form" novalidate id="sendCodeForm" name="sendCodeForm">
    <div class="row">
      <div class="fv-row mb-5">
        <label class="form-label fs-6 fw-bolder text-dark">{{ t('auth.sendCode.email') }}</label>
        <input class="form-control form-control-lg form-control-solid" required email trim
          [ngClass]="{'is-invalid' : userName && userName.touched && userName.invalid}" type="text" name="email"
          [(ngModel)]="email" #userName="ngModel" autocomplete="off" (change)="onEmailChangedDebounce()" />
        @if (userName && userName.touched && userName.errors && userName.errors.required) {
          <div class="invalid-feedback">{{ t('auth.sendCode.pleaseEnterEmail') }}</div>
        }
        @if (userName && userName.touched && userName.errors && userName.errors.email) {
          <div class="invalid-feedback">{{ t('auth.sendCode.pleaseEnterValidEmail') }}</div>
        }
      </div>
    </div>
    <div class="row">
      @if (email) {
        <div class="fv-row mb-5">
          <label class="form-label fs-6 fw-bolder text-dark">{{ t('auth.sendCode.company') }}</label>
          <select class="form-control form-control-lg form-control-solid" required
            [ngClass]="{'is-invalid' : company && company.touched && company.invalid}" name="company"
            [(ngModel)]="userCompanyGuid" #company="ngModel" autocomplete="off">
            <option value="">{{ t('common.selectOne') }}</option>
            @for (company of availableCompanies; track company.userCompanyGuid) {
              <option [ngValue]="company.userCompanyGuid">{{company.companyName}}</option>
            }
          </select>
          <div class="invalid-feedback">{{ t('auth.sendCode.pleaseSelectCompany') }}</div>
        </div>
      }
    </div>
  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  <button type="submit" class="btn btn-primary" (click)="onSendCodeClicked()">
    <span class="indicator-label">{{sendCodeButtonText}}</span>
    @if (spinnerVisible) {
      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
    }
  </button>
</div>
</ng-container>
